import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Bedroom from './Bedroom';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  postAPI_Create_Room,
  gAPI_QuestionOptionList,
  API_Ingetration_Channels,
  gAPI_Response_Amadeus,
  gAPI_Response_Mews,
} from '../../../../../constants/APIs';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';
import CategoryTag from './CategoryTag';
const AddRoomForm = ({
  visible,
  toggle,
  room,
  propertyId,
  locale,
  categoryList,
}) => {
  const [roomData, setRoomData] = useState({
    type: '',
    numberRoomsInProperty: 0,
    nameStatements: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    descriptionStatements: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    standardCapacity: 0,
    minimumAdults: 0,
    maximumAdults: 0,
    maximumChildren: 0,
    maximumInfants: 0,
    extraBedsAllowed: false,
    numberBedrooms: 0,
    numberLivingRooms: 0,
    measurementUnit: 'sqmt',
    floorSize: 0,
    balconyArea: 0,
    bedArrangements: [
      {
        name: 'Arrangment',
        beds: [],
      },
    ],
    creator: 'bmbdashboard',
    displayOrder: 1,
    bookingUrl: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    searchTags: [],
    bookingEngineCode: '',
    views: false,
    viewsDescription: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    provider: '0',
    providerRoomCode: '',
    searchCategoryTags: [],
  });
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [isViewDescription, setIsViewDescription] = useState(false);
  const [isAddBedroom, setIsAddBedroom] = useState(false);
  const [isProvider, setIsProvider] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [providerNames, setProviderNames] = useState([]);
  const [providerRooms, setProviderRooms] = useState([]);
  const [tags, setTags] = useState([]);
  const [categoriesData, setCategoriesData] = useState([
    ...categoryList,
    { label: 'Add New', value: 'new' },
  ]);
  const [selectedCategoryTags, setSelectedCategoryTags] = useState([]);
  const [addCategoryVisible, setAddCategoryVisible] = useState(false);
  const [editCategoryVisible, setEditCategoryVisible] = useState(false);

  const handleAddFields = () => {
    const values = [...roomData.bedArrangements];
    values.push({
      name: 'Arrangment',
      beds: [],
    });
    setRoomData({ ...roomData, bedArrangements: values });
  };
  const handleRemoveBedRooms = (index) => {
    const values = [...roomData.bedArrangements];
    values.splice(index, 1);
    setRoomData({ ...roomData, bedArrangements: values });
  };
  const initBed = {
    beds: [
      {
        type: '',
        count: '',
      },
    ],
  };

  const tryParseInt = (str, defaultValue) => {
    var retValue = defaultValue;
    if (str !== null) {
      if (str.length > 0) {
        if (!isNaN(str)) {
          retValue = parseInt(str);
        }
      }
    }
    return retValue;
  };

  const handleChange = (e) => {
    e.persist();

    if (
      e.target.name === 'nameStatements' ||
      e.target.name === 'descriptionStatements' ||
      e.target.name === 'bookingUrl' ||
      e.target.name === 'viewsDescription'
    ) {
      setRoomData({
        ...roomData,
        [e.target.name]: [
          {
            statement: e.target.value,
            languageCode: locale,
          },
        ],
      });
    } else {
      const value =
        tryParseInt(e.target.value, 0) === 0
          ? e.target.value
          : parseInt(e.target.value);
      if (e.target.name === 'extraBedsAllowed') {
        const extraBedAllowed = e.target.value ? true : false;
        setRoomData({ ...roomData, [e.target.name]: extraBedAllowed });
      } else if (e.target.name === 'views') {
        const views = e.target.checked ? true : false;
        if (e.target.checked) {
          setIsViewDescription(true);
        } else {
          setIsViewDescription(false);
        }
        setRoomData({ ...roomData, [e.target.name]: views });
      } else {
        setRoomData({ ...roomData, [e.target.name]: value });
      }
      if (e.target.name === 'provider') {
        if (e.target.value === 'Amadues') {
          const providers = providerNames.filter(
            (m) => m.name == e.target.value
          );
          AxiosAPI({
            method: 'get',
            url: `${gAPI_Response_Amadeus}/${providers[0].iid
              }/gethotelrooms?group_id=${getGroupID()}`,
          })
            .then((res) => {
              var options = [];
              console.log(res.data);
              const rooms = res.data.guestRooms.filter(
                (m) => m.roomStatus === 'active'
              );
              try {
                rooms.map((item) =>
                  options.push({
                    id: item.id,
                    name: item.roomTypeName,
                  })
                );
              } finally {
              }
              setProviderRooms(options);
            })
            .catch((err) => console.log('err', err));
          setIsProvider(true);
        } else if (e.target.value === 'Mews') {
          const providers = providerNames.filter(
            (m) => m.name == e.target.value
          );
          AxiosAPI({
            method: 'get',
            url: `${gAPI_Response_Mews}/${providers[0].iid
              }/gethotelrooms?group_id=${getGroupID()}`,
          })
            .then((res) => {
              var options = [];
              try {
                res.data.map((item) =>
                  options.push({
                    id: item.id,
                    name: item.name['en-US'],
                  })
                );
              } finally {
              }
              setProviderRooms(options);
            })
            .catch((err) => console.log('err', err));
          setIsProvider(true);
        } else {
          setIsProvider(false);
        }
      }
    }
  };
  const handleChangeCategoryTags = (selectedOptions) => {
    if (selectedOptions.filter((i) => i.value === 'new').length === 0) {
      setSelectedCategoryTags(selectedOptions);
      const categoriesArr = selectedOptions.map((elem) => elem.value);

      setRoomData({
        ...roomData,
        searchCategoryTags: categoriesArr,
      });
    } else {
      setAddCategoryVisible(true);
    }
  };
  const handleAddCategoryTag = (data, oldtitle) => {
    let allcate = [...categoriesData];
    let selectedCate = [...selectedCategoryTags];
    var newVariable = { label: data, value: data };
    selectedCate.push(newVariable);
    allcate.push(newVariable);
    if (oldtitle !== undefined) {
      selectedCate = selectedCate
        .filter((l) => l.value !== oldtitle)
        .map((l) => l);
      allcate = allcate.filter((l) => l.value !== oldtitle).map((l) => l);
    }
    setCategoriesData(allcate);
    setSelectedCategoryTags(selectedCate);
    setRoomData({
      ...roomData,
      searchCategoryTags: selectedCate.map((l) => l.value),
    });
  };
  const handleSaveRoom = async () => {
    let data = roomData;
    //data = data['creator'] = 'Test';
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Room}/${propertyId}`,
      data: data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Rooms`,
    })
      .then((res) => {
        var options = [];
        try {
          res.data.map((item) =>
            options.push({
              label: item.option,
              value: item.option,
              key: item.id,
            })
          );
        } finally {
        }
        setTags(options);
      })
      .catch((err) => console.log('err', err));

    let body = {
      channels: ['Amadues', 'Mews'],
    };

    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      const amadeusIntegration = res.data.filter(
        (k) => k.channel === 'Amadues' && k.properties.includes(propertyId)
      );
      const mewsIntegration = res.data.filter(
        (k) => k.channel === 'Mews' && k.properties.includes(propertyId)
      );
      if (amadeusIntegration.length > 0) {
        const values = [...providerNames];
        values.push({
          id: 1,
          name: 'Amadeus',
          iid: amadeusIntegration[0].id,
        });
        setProviderNames(values);
        console.log(values);
      }
      if (mewsIntegration.length > 0) {
        const values = [...providerNames];
        values.push({
          id: 1,
          name: 'Mews',
          iid: mewsIntegration[0].id,
        });
        setProviderNames(values);
        console.log(values);
      }
    });
  }, []);
  const handleChangeTags = (selectedTags) => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags.map((elem) => elem.value);

    setRoomData({
      ...roomData,
      searchTags: tagsArr,
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}><IntlMessages id='dashboards.add-room' /></ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Form>
                {/* <pre>{JSON.stringify(roomData, null, 2)}</pre> */}
                <FormGroup row>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="type">
                        <IntlMessages id='dashboards.room-type' />
                      </Label>

                      <Input
                        type="select"
                        onChange={handleChange}
                        name="type"
                        id="type"
                      >
                        <option value="">Choose Room Type</option>
                        <option value="Accommodation">Accommodation</option>
                        <option value="Apartment">Apartment</option>
                        <option value="Bed in Dormitory">
                          Bed in Dormitory
                        </option>
                        <option value="Bungalow">Bungalow</option>
                        <option value="Cabin">Cabin</option>
                        <option value="Caravan Site">Caravan Site</option>
                        <option value="Chalet">Chalet</option>
                        <option value="Dormitory room">Dormitory Room</option>
                        <option value="Double">Double</option>
                        <option value="Family">Family</option>
                        <option value="Family Unit">Family Unit</option>
                        <option value="Holiday home">Holiday Home</option>
                        <option value="House">House</option>
                        <option value="Mobile home">Mobile Home</option>
                        <option value="Motel Unit">Motel Unit</option>
                        <option value="Non Powered Site">
                          Non Powered Site
                        </option>
                        <option value="Other Unit (homesstead, villa etc)">
                          Other Unit (homesstead, villa etc)
                        </option>
                        <option value="Powered Site">Powered Site</option>
                        <option value="Quadruple">Quadruple</option>
                        <option value="Self Contained Unit">
                          Self Contained Unit
                        </option>
                        <option value="Single">Single</option>
                        <option value="Studio">Studio</option>
                        <option value="Suite">Suite</option>
                        <option value="Tent">Tent</option>
                        <option value="Tent Site (tent, yurt, teepee etc)">
                          Tent Site (tent, yurt, teepee etc)
                        </option>
                        <option value="Triple">Triple</option>
                        <option value="Twin">Twin</option>
                        <option value="Villa">Villa</option>
                      </Input>
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="standardCapacity">
                        {/* <IntlMessages id="forms.password" /> */}
                        <IntlMessages id='dashboards.how-many-guests' />
                      </Label>
                      <Input
                        type="number"
                        name="standardCapacity"
                        id="standardCapacity"
                        min={0}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="nameStatements">
                        {/* <IntlMessages id="forms.password" /> */}
                        <IntlMessages id='dashboards.room-name' />
                      </Label>
                      <Input
                        type="text"
                        name="nameStatements"
                        id="nameStatements"
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="numberRoomsInProperty">
                        <IntlMessages id='dashboards.number-of-rooms-this-type' />

                      </Label>
                      <Input
                        type="number"
                        name="numberRoomsInProperty"
                        id="numberRoomsInProperty"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="descriptionStatement">
                        {/* <IntlMessages id="forms.password" /> */}
                        <IntlMessages id='pages.description' />
                      </Label>
                      <Input
                        type="textarea"
                        name="descriptionStatements"
                        id="descriptionStatements"
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="numberBedrooms">
                        {/* <IntlMessages id="forms.password" /> */}
                        <IntlMessages id='dashboards.number-of-bedrooms' />
                      </Label>
                      <Input
                        type="number"
                        name="numberBedrooms"
                        id="numberBedrooms"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="numberOfLivingrooms">
                        {/* <IntlMessages id="forms.password" /> */}
                        <IntlMessages id='dashboards.number-of-livingrooms' />
                      </Label>
                      <Input
                        type="number"
                        name="numberLivingRooms"
                        id="numberLivingRooms"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        <IntlMessages id='dashboards.minimum-adults' />
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="minimumAdults"
                        id="minimumAdults"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        <IntlMessages id='dashboards.maximum-adults' />
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="maximumAdults"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        <IntlMessages id='dashboards.maximum-children' />
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="maximumChildren"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        <IntlMessages id='dashboards.maximum-infants' />
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="maximumInfants"
                        id="maximumInfants"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup className="m-4">
                      <Label>
                        <Input
                          type="checkbox"
                          name="extraBedsAllowed"
                          id="extraBedsAllowed"
                          onChange={handleChange}
                        />
                        <IntlMessages id='dashboards.extra-beds-allowed' />
                      </Label>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>

                        <IntlMessages id='dashboards.booking-engine-code' />
                      </Label>
                      <Input
                        type="text"
                        name="bookingEngineCode"
                        id="bookingEngineCode"
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="floorSize">
                        <IntlMessages id='dashboards.room-size' />
                      </Label>
                      <InputGroup>
                        <Input
                          type="number"
                          name="floorSize"
                          id="floorSize"
                          onChange={handleChange}
                        />
                        <InputGroupAddon addonType="append"></InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        <IntlMessages id='dashboards.balcony-area' />
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="balconyArea"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        <IntlMessages id='dashboards.unit' />
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="select"
                        onChange={handleChange}
                        name="measurementUnit"
                        id="measurementUnit"
                      >
                        <option value="Sqmt">square meters</option>
                        <option value="Sqft">square feet</option>
                      </Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="displayOrder">
                        {/* <IntlMessages id="forms.password" /> */}
                        <IntlMessages id='dashboards.displayOrder' />
                      </Label>
                      <Input
                        type="number"
                        name="displayOrder"
                        id="displayOrder"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup className="m-4">
                      <Label>
                        <Input
                          type="checkbox"
                          name="views"
                          id="views"
                          onChange={handleChange}
                        />{' '}
                        <IntlMessages id='dashboards.views' />
                      </Label>
                    </FormGroup>
                  </Colxx>
                  {isViewDescription && (
                    <Colxx sm={9}>
                      <FormGroup>
                        <Label>View Description</Label>
                        <Input
                          name="viewsDescription"
                          id="viewsDescription"
                          maxLength={30}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Colxx>
                  )}
                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="bookingUrl"><IntlMessages id='dashboards.bookingURL' /></Label>
                      <Input
                        type="text"
                        name="bookingUrl"
                        id="bookingUrl"
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="bookingUrl"><IntlMessages id='dashboards.searchTags' /></Label>
                      <Select
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        isMulti={true}
                        name="form-field-name"
                        value={selectedTags}
                        onChange={handleChangeTags}
                        options={tags}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="bookingUrl"><IntlMessages id='dashboards.searchCategoryTags' /></Label>
                      <Select
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        isMulti={true}
                        name="form-field-name"
                        value={selectedCategoryTags}
                        onChange={handleChangeCategoryTags}
                        options={categoriesData}
                      />
                      {categoriesData.length > 1 && (
                        <div className="d-flex justify-content-end mt-2">
                          <Button
                            outline
                            color="primary"
                            size="xs"
                            onClick={() => {
                              setEditCategoryVisible(!editCategoryVisible);
                              setAddCategoryVisible(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                            {''}
                            <IntlMessages id="survey.edit" />{' '}
                            <IntlMessages id="survey.category" />
                          </Button>
                        </div>
                      )}
                    </FormGroup>
                  </Colxx>
                  {providerNames.length > 0 && (
                    <Colxx sm={6}>
                      <FormGroup>
                        <Label for="provider"><IntlMessages id='dashboards.provider' /></Label>
                        <Input
                          type="select"
                          name="provider"
                          onChange={handleChange}
                        >
                          <option value="0">None</option>
                          {providerNames.map((name) => {
                            return (
                              <option value={name.name}>{name.name}</option>
                            );
                          })}
                        </Input>
                      </FormGroup>
                    </Colxx>
                  )}
                  {isProvider && (
                    <Colxx sm={6}>
                      <FormGroup>
                        <Label for="roomcode">Room</Label>
                        <Input
                          type="select"
                          name="providerRoomCode"
                          onChange={handleChange}
                        >
                          <option value="">None</option>
                          {providerRooms.map((name) => {
                            return <option value={name.id}>{name.name}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Colxx>
                  )}
                </FormGroup>
              </Form>
            </Colxx>
          </Row>
          {roomData.bedArrangements.map((oneBedroom, index) => {
            return (
              <Fragment key={index}>
                <Bedroom
                  oneBedroom={oneBedroom}
                  isAddBedroom={false}
                  roomData={roomData}
                  setRoomData={setRoomData}
                  handleRemoveBedRooms={handleRemoveBedRooms}
                  roomindex={index}
                />
              </Fragment>
            );
          })}
          {/* {isAddBedroom && (
            <Bedroom
              oneBedroom={initBed}
              isAddBedroom={isAddBedroom}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          )} */}
          <Row>
            <Colxx xxs="12">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={handleAddFields}
                style={{ width: '100%', borderRadius: '6px' }}
              >
                + <IntlMessages id='dashboards.addBedroom' />
              </Button>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSaveRoom}>
            <IntlMessages id='dashboards.save' />
          </Button>
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id='pages.cancel' />
          </Button>
        </ModalFooter>
      </Modal>
      {addCategoryVisible && (
        <CategoryTag
          visible={addCategoryVisible}
          toggle={() => setAddCategoryVisible(!addCategoryVisible)}
          handleAddCategoryTag={handleAddCategoryTag}
          categoryList={categoriesData}
          isEdit={editCategoryVisible}
        ></CategoryTag>
      )}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};
export default injectIntl(connect(mapStateToProps)(AddRoomForm));
